/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BookReportRequestModel,
    BookReportRequestModelFromJSON,
    BookReportRequestModelToJSON,
    BorrowViewRecordReportRequestModel,
    BorrowViewRecordReportRequestModelFromJSON,
    BorrowViewRecordReportRequestModelToJSON,
    Resource,
    ResourceFromJSON,
    ResourceToJSON,
} from '../models';

export interface ExportBookReportUsingPOSTRequest {
    bookReportRequestModel?: BookReportRequestModel;
}

export interface ExportBorrowViewRecordReportUsingPOSTRequest {
    borrowViewRecordReportRequestModel?: BorrowViewRecordReportRequestModel;
}

export interface ExportReadDataReportUsingPOSTRequest {
    startDate: Date;
    endDate: Date;
}

export interface SaveReportRecordUsingPOSTRequest {
    memberId: number;
    productId: number;
    reportType: SaveReportRecordUsingPOSTReportTypeEnum;
    bookType: SaveReportRecordUsingPOSTBookTypeEnum;
}

/**
 * 
 */
export class ReportRecordControllerApi extends runtime.BaseAPI {

    /**
     * export excel for Book report
     */
    async exportBookReportUsingPOSTRaw(requestParameters: ExportBookReportUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Resource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/reportRecord/export-Book-report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BookReportRequestModelToJSON(requestParameters.bookReportRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
     * export excel for Book report
     */
    async exportBookReportUsingPOST(requestParameters: ExportBookReportUsingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Resource> {
        const response = await this.exportBookReportUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * export excel for BorrowViewRecord report
     */
    async exportBorrowViewRecordReportUsingPOSTRaw(requestParameters: ExportBorrowViewRecordReportUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Resource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/reportRecord/export-BorrowViewRecord-report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BorrowViewRecordReportRequestModelToJSON(requestParameters.borrowViewRecordReportRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
     * export excel for BorrowViewRecord report
     */
    async exportBorrowViewRecordReportUsingPOST(requestParameters: ExportBorrowViewRecordReportUsingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Resource> {
        const response = await this.exportBorrowViewRecordReportUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * export excel for ReadData report
     */
    async exportReadDataReportUsingPOSTRaw(requestParameters: ExportReadDataReportUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Resource>> {
        if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
            throw new runtime.RequiredError('startDate','Required parameter requestParameters.startDate was null or undefined when calling exportReadDataReportUsingPOST.');
        }

        if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
            throw new runtime.RequiredError('endDate','Required parameter requestParameters.endDate was null or undefined when calling exportReadDataReportUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/reportRecord/export-ReadData-report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
     * export excel for ReadData report
     */
    async exportReadDataReportUsingPOST(requestParameters: ExportReadDataReportUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Resource> {
        const response = await this.exportReadDataReportUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * saveReportRecord
     */
    async saveReportRecordUsingPOSTRaw(requestParameters: SaveReportRecordUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.memberId === null || requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId','Required parameter requestParameters.memberId was null or undefined when calling saveReportRecordUsingPOST.');
        }

        if (requestParameters.productId === null || requestParameters.productId === undefined) {
            throw new runtime.RequiredError('productId','Required parameter requestParameters.productId was null or undefined when calling saveReportRecordUsingPOST.');
        }

        if (requestParameters.reportType === null || requestParameters.reportType === undefined) {
            throw new runtime.RequiredError('reportType','Required parameter requestParameters.reportType was null or undefined when calling saveReportRecordUsingPOST.');
        }

        if (requestParameters.bookType === null || requestParameters.bookType === undefined) {
            throw new runtime.RequiredError('bookType','Required parameter requestParameters.bookType was null or undefined when calling saveReportRecordUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.memberId !== undefined) {
            queryParameters['memberId'] = requestParameters.memberId;
        }

        if (requestParameters.productId !== undefined) {
            queryParameters['productId'] = requestParameters.productId;
        }

        if (requestParameters.reportType !== undefined) {
            queryParameters['reportType'] = requestParameters.reportType;
        }

        if (requestParameters.bookType !== undefined) {
            queryParameters['bookType'] = requestParameters.bookType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/reportRecord/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * saveReportRecord
     */
    async saveReportRecordUsingPOST(requestParameters: SaveReportRecordUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<void> {
        await this.saveReportRecordUsingPOSTRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const SaveReportRecordUsingPOSTReportTypeEnum = {
    BorrowTime: 'BORROW_TIME',
    CantBorrow: 'CANT_BORROW',
    Chapter: 'CHAPTER',
    Content: 'CONTENT',
    MobileBorrow: 'MOBILE_BORROW',
    Preview: 'PREVIEW',
    ReadOnline: 'READ_ONLINE',
    WebBorrow: 'WEB_BORROW'
} as const;
export type SaveReportRecordUsingPOSTReportTypeEnum = typeof SaveReportRecordUsingPOSTReportTypeEnum[keyof typeof SaveReportRecordUsingPOSTReportTypeEnum];
/**
 * @export
 */
export const SaveReportRecordUsingPOSTBookTypeEnum = {
    All: 'ALL',
    Audio: 'AUDIO',
    Ebook: 'EBOOK',
    Magazine: 'MAGAZINE'
} as const;
export type SaveReportRecordUsingPOSTBookTypeEnum = typeof SaveReportRecordUsingPOSTBookTypeEnum[keyof typeof SaveReportRecordUsingPOSTBookTypeEnum];
